import { RouteRecordRaw } from 'vue-router';

export default {
  path: '/customer',
  name: 'customer',
  redirect: '/customer/customer/index',
  component: () => import('@/layout/index.vue'),
  meta: {
    title: 'menus.customer',
    icon: 'el-icon-userFilled',
    sort: 3
  },
  children: [
    {
      path: '/customer/clue/index',
      name: 'customer_clue',
      component: () => import('@/views/customer/clue/index.vue'),
      meta: {
        title: 'menus.customer_clue',
        icon: 'el-icon-school'
      }
    },
    {
      path: '/customer/clue/detail',
      name: 'customer_clue_detail',
      component: () => import('@/views/customer/clue/detail.vue'),
      meta: {
        title: 'menus.customer_detail',
        isMenu: false
      }
    },
    {
      path: '/customer/customer/index',
      name: 'customer_customer',
      component: () => import('@/views/customer/customer/index.vue'),
      meta: {
        title: 'menus.customer_customer',
        icon: 'el-icon-user'
      }
    },

    {
      path: '/customer/configFollowStatus/index',
      name: 'customer_configFollowStatus',
      component: () => import('@/views/customer/configFollowStatus/index.vue'),
      meta: {
        title: 'menus.customer_configFollowStatus',
        icon: 'el-icon-Tools'
      }
    },
    {
      path: '/customer/customerTag/index',
      name: 'customer_customerTag',
      component: () => import('@/views/customer/customerTag/index.vue'),
      meta: {
        title: 'menus.customer_customerTag',
        icon: 'el-icon-collectionTag'
      }
    }
  ]
} as RouteRecordRaw;
